import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Typography,
  VertButton,
  VertContainer,
  VertModal,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import * as yup from 'yup';

const ModalCotacao = ({
  isVisible,
  submitApprove,
  setIsVisible,
  quote = null,
}) => {
  const [form] = Form.useForm();

  const schema = yup.object().shape({
    description: yup.string().required('Comentário é obrigatório'),
  });

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <VertModal
      title="Reenviar Nova Cotação"
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={
        <Row justify="space-between">
          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              className="button-view-redemption"
              onClick={() => setIsVisible(false)}
            >
              CANCELAR
            </VertButton>
          </Col>

          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              type="highlight"
              className="button-view-redemption"
              htmlType="submit"
              form="form-quote"
            >
              SIM
            </VertButton>
          </Col>
        </Row>
      }
    >
      <VertContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography.Text>
            Certeza que deseja{' '}
            <Typography.Text strong> reenviar</Typography.Text> essa solicitação
            para nova cotação?
          </Typography.Text>

          {quote !== null ? (
            <Typography.Text>
              Ao clicar em
              <Typography.Text
                strong
                style={{
                  margin: '0 5px',
                }}
              >
                SIM
              </Typography.Text>
              ,você estará retornando esta solicitação para novos orçamentos.
            </Typography.Text>
          ) : (
            <Typography.Text>
              {' '}
              Ao clicar em <Typography.Text strong>SIM</Typography.Text> você
              aprovará esta solicitação.
            </Typography.Text>
          )}

          <Form
            style={{
              marginBottom: '20px',
              marginTop: '20px',
              width: '100%',
            }}
            form={form}
            scrollToFirstError
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            onFinish={submitApprove}
            id="form-quote"
          >
            <Form.Item
              name="description"
              rules={[yupSync]}
              validateTrigger="onBlur"
            >
              <Input.TextArea
                className="modal-text-area"
                placeholder="* Deixe seu comentário"
              />
            </Form.Item>
          </Form>
        </div>
      </VertContainer>
    </VertModal>
  );
};

ModalCotacao.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  submitApprove: PropTypes.func.isRequired,
  quote: PropTypes.object,
};

export default ModalCotacao;
